export const tradingContest = {
  cyjyds: "Tham gia cuộc thi giao dịch",
  jsjxmh: "Mở khóa hộp mù bất ngờ và giành giải thưởng siêu khủng",
  hdsj: "Thời gian hoạt động",
  mrjxsj: "Được thực hiện từ 00:00 đến 23:59 UTC+8 mỗi ngày.",
  ckxxgz: "Quy tắc chi tiết",
  wdjj: "tiền thưởng của tôi",
  jlkj: "Đếm ngược",
  cjjc: "Nhóm siêu giải thưởng",
  jjmrzj: "Tiền thưởng tăng hàng ngày",
  kqxjd: "Mở một giai đoạn mới và tăng số lượng phần thưởng",
  dyjd: "Giai đoạn 1",
  dejd: "Giai đoạn 2",
  dsjd: "Giai đoạn 3",
  dsijd: "Giai đoạn 4",
  jrmhjj: "Phần thưởng hộp mù hôm nay",
  syjj: "tiền thưởng còn lại",
  yblqje: "Số tiền nhận được",
  tjmh: "Đặc biệt",
  yjmh: "Hộp 1 tầng",
  ejmh: "Hộp 2 tầng",
  sjmh: "Hộp 3 tầng",
  jj: "Tiền thưởng: ",
  gs: "cái",
  djdkrymh: "Bấm để mở bất kỳ hộp mù bất ngờ nào",
  kydk: "Bạn có thể mở nó ngay hôm nay",
  jxmh: "Hộp mù bất ngờ",
  dkmhxyxx: "Cần {amount} sao để mở hộp mù. ",
  xzyyxx: "Bây giờ bạn có {amount} sao",
  xxqlsj: "Thời gian dọn sao: {date} （Vui lòng thu thập hộp mù trước khi dọn sao）",
  wdxx: "ngôi sao của tôi",
  xxhq: "Thu thập sao",
  hqxxtj: "Làm thế nào để có được ngôi sao",
  yxhysxf: "Hợp đồng vĩnh viễn: Kiếm 1 sao cho mỗi {amount}U phí xử lý",
  qqhysxf: "Hợp đồng quyền chọn: Kiếm 1 sao cho mỗi {amount}U khối lượng giao dịch",
  youxihysxf: "GameFi: Kiếm 1 sao cho mỗi {amount}U khối lượng giao dịch",
  gxhd: "Xin chúc mừng",
  jlydrzh: "Phần thưởng đã được ghi có vào '{account}' của bạn",
  qzjzhck: "Vào tài khoản Gamefi để xem",
  bwcjjc: "Giải thưởng siêu khủng",
  qmxjyds: "Cuộc thi giao dịch toàn sao",
  gbgbyb: "Bạn có dám thử không?",
  bwcjjcdnn: "Giải thưởng siêu xe đạp, {amount}% giải thưởng hộp mù dành cho bạn mỗi ngày!",
  cjjcqmxjys: "{amount}% tổng giải thưởng của Cuộc thi giao dịch toàn sao Biking Super Prize Pool được thêm vào hộp mù mỗi ngày. ",
  syyxbd: "Chỉ cần mở nó và giành chiến thắng với số tiền nhỏ!",
  zgtk: "Bạn muốn đạt đến đỉnh cao? Hãy đến và chiến đấu!",
  zhyz: "{amount}% tổng giải thưởng hàng ngày được tích lũy cho đến trận chiến cuối cùng. ",
  dfdj: "Ai có thể giành được giải cao nhất của môn Đua xe đạp?",
  gsjj: "Các chuyên gia của Cuộc thi giao dịch toàn sao của Coin King Super Prize Pool đã tụ họp lại với nhau,",
  qmxpk: "Bài kiểm tra thực sự của All-Star PK!",
  jymh: "Giao dịch, hộp mù, xếp hạng và vui chơi trong Đấu trường xe đạp!",
  zzbzy: "Hợp đồng vĩnh viễn, quyền chọn, GameFi, giao dịch giao ngay, lối chơi xung quanh được nâng cấp từng lớp và không bao giờ giống nhau mỗi tuần!",
  jlfh: "Cuộc thi giao dịch toàn sao dành cho giải đua xe đạp siêu giải thưởng, những phần thưởng hậu hĩnh đang chờ bạn đạt được danh tiếng, tài sản và trở thành anh hùng!",
  mh: "hộp mù",
  cb: "Vội vã lên đỉnh",
  jy: "Giao dịch",
  syxxs: "Số sao còn lại",
  xxbhs: "Số lượng sao thay đổi",
  sjlx: "loại sự kiện",
  jycp: "Sản phẩm kinh doanh",
  jye: "Khối lượng giao dịch",
  myxgjl: "Bạn chưa nhận được bất kỳ phần thưởng liên quan nào",
  jyhd: "Giao dịch đạt được",
  ql: "Thông thoáng",
  kqmh: "Mở hộp mù",
  yx: "trò chơi GameFi",
  bchdyjs: "Sự kiện này đã kết thúc",
  gffjj: "Tổng giải thưởng sẽ được phân bổ trong cuộc thi này",
  kqmhsl: "Kích hoạt số lượng hộp mù",
  cjjcjj: "Tiền thưởng siêu jackpot",
  cjjchjmd: "Danh sách người chiến thắng giải thưởng siêu lớn",
  jjdyyh: "Tiền thưởng đã được ghi có vào tài khoản quỹ của người dùng",
  hdjj: "nhận được tiền thưởng",
  wff: "Không được phát hành",
  mhhjjl: "Hộp mù",
  cjdjhjjl: "Giải thưởng siêu khủng",
  jjse: "Số tiền thưởng",
  xhxxs: "Số lượng sao tiêu thụ",
  bwqmxgz: "Thể lệ cuộc thi giao dịch xe đạp All-Star",
  hdnr: "Nội dung hoạt động",
  hdnrgz: "Cuộc thi giao dịch toàn sao dành cho nhóm siêu giải thưởng dành cho xe đạp bao gồm bốn lĩnh vực chính: hợp đồng vĩnh viễn, hợp đồng quyền chọn, trò chơi GameFi và giao dịch giao ngay. Sự kiện được chia thành bốn tuần và các sản phẩm giao dịch mới được mở khóa dần dần hàng tuần, cho phép bạn nhận được 'ngôi sao' trong các thử thách giao dịch đa chiều và giành được phần thưởng hậu hĩnh. {total}% tổng giải thưởng hàng ngày được sử dụng để rút hộp mù và các phần thưởng bất ngờ sẽ có sẵn ngay lập tức! {amount}% còn lại sẽ được tích lũy cho đến khi kết thúc cuộc thi và phần thưởng cao nhất sẽ được chia theo xếp hạng giao dịch!",
  hdjd: "Giai đoạn hoạt động",
  jbjs: "Dần dần mở khóa, bốn chu kỳ nâng cấp cạnh tranh",
  dyzq: "Chu kỳ đầu tiên",
  kqyxhy: "Cho phép giao dịch hợp đồng vĩnh viễn. Khối lượng giao dịch càng cao, điểm sao càng nhiều và phần thưởng tổng giải thưởng càng cao!",
  dezq: "Chu kỳ thứ hai",
  jmqqjy: "Tăng giao dịch hợp đồng quyền chọn và nhận được giải độc đắc hai chiều cho lãi và lỗ, cho phép bạn nâng cấp lại số sao của mình.",
  dszq: "Chu kỳ thứ ba",
  cjgejc: "Tham gia trò chơi GameFi, kiếm sao thông qua trải nghiệm giao dịch đa dạng và đạt được giải thưởng cao.",
  dsizq: "Chu kỳ thứ tư",
  gfzzdj: "Nhóm giải thưởng hộp mù sẽ tiếp tục được mở trong ba tuần đầu tiên và danh sách giao dịch giao ngay sẽ được thiết lập riêng để chia sẻ giải thưởng cuối cùng!",
  jzszjs: "Tính toán giải thưởng",
  jxmhgz1: "Mỗi ngày, {amount}% hàng hóa được phân phối vào hộp mù, 100 hộp mù được mở ngay lập tức và bốn loại hàng hóa được giao cùng lúc. Chưa được thu thập. Khuyến khích phát triển bản thân đã đến vào ngày hôm sau, và lợi nhuận đã tăng lên! Hộp mù cấp đặc biệt, hộp mù cấp một, v.v. được cập nhật hàng ngày và tỷ lệ đặt hàng trung bình siêu cao, v.v. đang đến!",
  mhfpmx: "Số lượng hộp mù là {total} mỗi ngày và số lượng hộp mù là {amount}%. Chi tiết phân phối hộp mù:",
  tjmhzb: "{total} hộp mù đặc biệt chiếm {amount}% tổng giải thưởng",
  yjmhzb: "Có {total} ô mù cấp 1 chiếm {amount}% tổng giải thưởng",
  ejmhzb: "Có {total} ô mù phụ chiếm {amount}% tổng giải thưởng",
  sjmhzb: "Có {total} ô mù cấp 3, chiếm {amount}% tổng giải thưởng.",
  kmhxxyq: "Số sao cần thiết để mở hộp mù: tổng giải thưởng hộp mù hàng ngày/{text}",
  tips: "Lưu ý: 0 mục được cập nhật mỗi ngày khi mở sách và tính số tiền cộng vào số tiền đã mở ngày hôm trước.",
  mrjyyk: "Tổng giải thưởng dựa trên lãi và lỗ giao dịch hàng ngày trong ba lĩnh vực chính là hợp đồng vĩnh viễn, hợp đồng quyền chọn và GameFi.",
  mgyld: "{amount}% của mỗi lệnh lợi nhuận = số tiền lãi * {amount}%",
  mrjcljdjs: "{amount}% tổng giải thưởng hàng ngày sẽ được tích lũy cho đến khi kết thúc sự kiện và sẽ được chia cho ba người đứng đầu trong bảng xếp hạng của bốn sản phẩm giao dịch chính. Tỷ lệ của tổng giải thưởng tiếp tục là: 40% cho hợp đồng vĩnh viễn, 30% cho quyền chọn, 20% cho GameFi và 10% cho sản phẩm giao ngay.",
  yhhyyld: "Ví dụ: nếu lợi nhuận đặt hàng hợp đồng của người dùng là 1000U thì 1000*{amount}%={total}U sẽ được tính vào tổng giải thưởng của ngày",
  mgksd: "{amount}% của mỗi lệnh thua = số tiền thua lỗ thực tế (lỗ - thanh lý) * {amount}%",
  yhhyks: "Ví dụ: nếu đơn đặt hàng hợp đồng của người dùng thực sự thua 1000U, thì 1000*{amount}%={total}U sẽ được tính vào tổng giải thưởng của ngày.",
  qqhyyld: "{amount}% của mỗi lệnh lợi nhuận = số tiền đặt cược * tỷ lệ cược * {amount}%",
  qqyhddtz: "Ví dụ: nếu người dùng đặt cược 100U cho một lệnh tùy chọn và kiếm được lợi nhuận trong khoảng thời gian 10 giây thì 100*65%*{amount}%={total}U sẽ vào tổng giải thưởng của ngày.",
  qqhyksd: "{amount}% của mỗi lệnh thua = số tiền thua * {amount}%",
  yhksjrjc: "Ví dụ: nếu lỗ lệnh tùy chọn của người dùng là 100U thì 100*{amount}%={total}U sẽ được tính vào tổng giải thưởng của ngày.",
  yxyld: "{amount}% của mỗi lệnh lợi nhuận = số tiền đặt cược * tỷ lệ cược * {amount}%",
  yxddtz: "Ví dụ: Người dùng đặt lệnh gamefi đặt cược 100U, giả sử tỷ lệ cược là 2 lần. Nếu bạn kiếm được lợi nhuận, 100*200%*{amount}%={total}U sẽ vào tổng giải thưởng của ngày.",
  yxmgksd: "{amount}% của mỗi lệnh thua = số tiền thua * {amount}%",
  yhqqksd: "Ví dụ: nếu lỗ lệnh quyền chọn của người dùng là 100U thì 100*{amount}%={total}U sẽ được tính vào tổng giải thưởng của ngày.",
  daiding: "Để được xác định",
  yytz: "Điều chỉnh hoạt động",
  kaiqi: "Mở",
  xhjyjrpm: "Giao dịch giao ngay gia nhập bảng xếp hạng",
  drjy: "Giao dịch trong ngày và nhận được vào ngày hôm sau",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/tradingContest/vi.js